export const GENERAL_CHECK_IN_INSTRUCTIONS_TEXT =
  "Once you've completed your booking, keep an eye out for emails from your host. They will provide important information about your check-in process and address any questions you may have regarding the property or your stay.";
export const PAYMENT_POLICY_FULL_PAYMENT_DUE_NOW =
  "Full payment is due at the time of booking.";
export const PAYMENT_POLICY_CARD_ON_FILE =
  "If you cause damage to the property or incur incidental fees, your card may be charged.";
export const PAYMENT_POLICY_DUE_BEFORE_CHECKIN =
  "Full payment is due before check-in.";
export const PAYMENT_POLICY_TITLE = "Payment Policy";
